import utils from "Sources/utils/utils";
import request from "Sources/services/request";

let SessionService = {};

((SessionService) =>
{
  SessionService.getSessionsForUser = function()
  {
    return request.get({
      url:  utils.getServiceUrl("/sessions"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(SessionService.onServiceComplete);
  };

  SessionService.isStarted = function(key)
  {
    return request.get({
      url:  utils.getServiceUrl("/sessions/" + key + "/is_started"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(SessionService.onServiceComplete);
  };

  SessionService.getStatus = function(key)
  {
    return request.get({
      url:  utils.getServiceUrl("/sessions/" + key + "/status"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(SessionService.onServiceComplete);
  };

  SessionService.getMaterialsForSession = function(key)
  {
    return request.get({
      url:  utils.getServiceUrl("/sessions/" + key + "/materials"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(SessionService.onServiceComplete);
  };

  SessionService.generatePdf = function(key)
  {
    return request.post({
      url:  utils.getServiceUrl("/sessions/" + key + "/pdf"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(SessionService.onServiceComplete);
  };

  SessionService.startSession = function(key, showWizard, materialsForSessionList)
  {
    let data = {
      showWizard: showWizard,
      materials : materialsForSessionList
    };

    return request.post({
      url:  utils.getServiceUrl("/sessions/" + key + "/start"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: data
    })
      .then(SessionService.onServiceComplete);
  };

  SessionService.getSession = function(key)
  {
    return request.get({
      url:  utils.getServiceUrl("/sessions/" + key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON
    })
      .then(SessionService.onServiceComplete);
  };

  SessionService.createSession = function(sessionObj)
  {
    return request.post({
      url:  utils.getServiceUrl("/sessions"),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: sessionObj
    })
      .then(SessionService.onServiceComplete);
  };

  SessionService.updateSession = function(sessionObj)
  {
    return request.put({
      url:  utils.getServiceUrl("/sessions/" + sessionObj.key),
      cache: false,
      dataType: request.DATA_TYPES.JSON,
      contentType: request.CONTENT_TYPES.APPLICATION_JSON,
      data: sessionObj
    })
      .then(SessionService.onServiceComplete);
  };

  SessionService.setThumb = function(sessionKey, thumbKey)
  {
    return request.post({
      url: utils.getServiceUrl("/sessions/" + sessionKey + "/set_thumb"),
      cache: false,
      data:
        {
          thumb_key: thumbKey
        }
    }).then(SessionService.onServiceComplete);
  }

  SessionService.deleteSession = function(sessionKey)
  {
    return request.delete({
      url:  utils.getServiceUrl("/sessions/" + sessionKey),
      cache: false
    })
      .then(SessionService.onServiceComplete);
  };

  SessionService.copySession = function(sessionKey)
  {
    return request.post({
      url:  utils.getServiceUrl("/sessions/" + sessionKey + "/copy"),
      cache: false
    })
      .then(SessionService.onServiceComplete);
  }

  SessionService.addMission = function(sessionKey, missionKey)
  {
    return request.post({
      url:  utils.getServiceUrl("/sessions/" + sessionKey + "/add_mission/" + missionKey),
      cache: false
    })
      .then(SessionService.onServiceComplete);
  }

  SessionService.onServiceComplete = function (data)
  {
    if(utils.isNotNull(data) && data.result === "success" && data.data)
    {
      return data.data;
    }

    return null;
  }

})(SessionService);

module.exports = SessionService;



// WEBPACK FOOTER //
// ./app/js/services/session-service.js